import * as z from "zod";
import { normalizedConnectorIdentity } from "../connectors/normalizeUrlPattern";
import { mutator } from "./mutator";
import { stringRecord } from "./utils";

export const updateConnectorSchema = z.object({
  connectedAppId: z.string(),
  name: z.string(),
  identifier: z.string(),
  urlPattern: z.string(),
  configuration: stringRecord,
  secrets: stringRecord.optional(),
  oauthConnectionId: z.string().optional(),
  note: z.string().optional(),
});

export const updateConnectedApp = mutator({
  redactKeys: ["secrets"],
  schema: updateConnectorSchema,
  resolve: {
    app: { kind: "connectedApp", from: "connectedAppId" },
    oauthConnection: {
      kind: "oauthConnection",
      from: "oauthConnectionId",
      optional: true,
    },
  },
  permissions: [
    {
      permission: "connected_app:write",
      scopeId: ({ args }) => args.app.id,
    },
  ],
  fn: async ({
    tx,
    args: {
      app,
      name,
      identifier,
      urlPattern,
      configuration,
      oauthConnectionId,
      note,
    },
  }) => {
    await tx.mutate.connectedApps.update({
      id: app.id,
      ...normalizedConnectorIdentity({
        name,
        identifier,
        urlPattern,
        configuration,
        previousConfiguration: app.configuration,
      }),
      ...(oauthConnectionId !== undefined && { oauthConnectionId }),
      ...(note !== undefined && { note }),
    });
  },
});
